import styled from "@emotion/styled";

import { StyledCell } from "../Cell/Cell.styled";

export const TableHeaderStyled = styled(StyledCell)`
  word-break: normal;
`;
